import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const notifications = ['Olivia from Auckland just purchased this digital MegaPack', 'Liam from Wellington just got instant access', 'Charlotte from Christchurch just purchased The Pawfect Shot MegaPack', 'Noah from Hamilton just bought this ebook bundle', 'Amelia from Tauranga just purchased this digital guide', 'Jack from Dunedin just got access now'];
function getRandomDelay() {
  // Random delay between 15 and 20 seconds
  return 15000 + Math.random() * 5000;
}
export function PurchaseNotification() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const timerRef = useRef<any>(null);
  useEffect(() => {
    // Initial delay before first popup (15-20 seconds)
    timerRef.current = setTimeout(() => {
      setIsVisible(true);
    }, 15000 + Math.random() * 5000);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    // Hide after 3.5 seconds
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
      // Move to next notification
      setCurrentIndex(prev => (prev + 1) % notifications.length);
      // Show next after 15-20 seconds (randomized)
      timerRef.current = setTimeout(() => {
        setIsVisible(true);
      }, getRandomDelay());
    }, 3500);
    return () => clearTimeout(hideTimer);
  }, [isVisible]);
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-210">
      <AnimatePresence data-id="element-211">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.95
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-white rounded-lg shadow-xl border border-gray-100 p-4 flex items-center gap-4 max-w-sm" data-id="element-212">
            <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0" data-id="element-213">
              <span className="text-green-600 text-xl" data-id="element-214">✓</span>
            </div>
            <div data-id="element-215">
              <p className="font-sans text-sm text-gray-800 font-medium leading-tight" data-id="element-216">
                {notifications[currentIndex]}
              </p>
              <p className="font-sans text-xs text-gray-400 mt-1" data-id="element-217">Just now</p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}